import "./index.css";
import { useEffect, useContext, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DashboardCounter from "../../components/DashboardCounter/index";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import PageLayout from "../../layouts/PageLayout";
import Ico1 from "../../assets/img/edit.png";
import Ico2 from "../../assets/img/delete.png";
import Ico3 from "../../assets/img/s.png";
import Ico4 from "../../assets/img/d.png";
import Clap from "../../assets/img/clap.png";
import Diconetwo from "../../assets/img/real_time.svg";
import Diconethree from "../../assets/img/active_daily_mgmt.svg";
import Iconone from "../../assets/img/beds.png";
import Icontwo from "../../assets/img/compliance.png";
import Iconthree from "../../assets/img/variance.png";
import Iconfour from "../../assets/img/hpuoc.png";
import Ico22 from "../../assets/img/info.png";
import Ico33 from "../../assets/img/warning.png";
import Ico44 from "../../assets/img/critical.png";
import { get } from "lodash";
import { API_CALL_URL_PRIVATE } from "../../constants";
import axios from "../../axios";
import { DOMAIN_URL } from "../../constants/compensate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactPaginate from "react-paginate";
import { setLoadingPage } from "../../store/actions";
import { flushSync } from "react-dom";
import AscIcon from "../../assets/img/desc.png";
import DescIcon from "../../assets/img/asc.png";
import Select from "react-select";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import calcIcon from "../../assets/img/calculator_hires.png";
import MultiSelect from "../../components/MultiSelectCustom/MultiSelectActivity";
import { ThemeContext } from "../../providers/ThemeProvider";

function Applications(props) {
  const dispatch = useDispatch();
  const [theme, setTheme] = useContext(ThemeContext);
  const userData = JSON.parse(localStorage.getItem("psAdmin"))?.data;
  const customer_code = useSelector((state) => state.compensate.customerCode);
  const loading_page = useSelector((state) => state.compensate.LoadingPage);
  console.log(customer_code, "customercode");
  const [dashboardData, setDashboardData] = useState([]);
  const [costCenterList, setCostCenterList] = useState([]);
  const [customerData, setCustomerData] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [pageLimit, setPageLimit] = useState(50);
  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [hasPrev, setHasPrev] = useState(false);
  const [hasNext, setHasNext] = useState(false);
  const [sortKey, setSortKey] = useState("");
  const [isInitialData, setISInitialData] = useState(false);
  const [sortOrder, setSortOrder] = useState(1);
  const [searchTempKeyword, setSearchTempKeyword] = useState("");
  const boxdata = props.data;
  const isLoader = props.isLoader;
  const { issearch } = props;
  const [pageCounter, setPageCounter] = useState("");
  const [listLoader, setListLoader] = useState(false);
  const [searchActive, setSearchActive] = useState(false);
  const [fieldFilterOptions, setFieldFilterOptions] = useState([
    { label: "Patient Data", value: "patient_data" },
    { label: "Staffing", value: "staffing" },
    { label: " Additional Data Tracking", value: "additional_data_tracking" },
  ]);
  const [fieldType, setFieldType] = useState([]);

  function getDate(inputDate) {
    const timeZone = "America/Los_Angeles";
    const date = new Date(inputDate).toLocaleString("en-US", {
      timeZone,
      hour12: true,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });

    return date;
  }

  const renderElements = () => {
    return Array.from({ length: totalPages }, (_, index) => (
      <span
        key={index + 1}
        className={
          index + 1 === currentPage
            ? "paginate_button current"
            : "paginate_button"
        }
        aria-controls="example"
        role="link"
        aria-current="page"
        data-dt-idx="0"
        tabindex="0"
        onClick={() => {
          setCurrentPage(index + 1);
        }}
      >
        {index + 1}
      </span>
    ));
  };

  useEffect(() => {
    const getCustomerDetailList = async () => {
      try {
        const resp = await axios.post(
          `${API_CALL_URL_PRIVATE}/workdriverGraphField/list`,
          {
            customer_code: parseInt(customer_code),
            searchKeyword: searchKeyword,
            limit: pageLimit,
            page: searchActive ? 1 : currentPage,
            sort_column: searchActive ? "" : sortKey,
            sort_order: searchActive ? 1 : sortOrder,
            category_ids: fieldType?.map((e) => e.value).join(","),
          }
        );

        const Data = resp?.data?.data?.data;
        console.log("mpx", Data);
        setSearchActive(false);
        setCustomerData(Data);
        setPageLimit(Data?.limit);
        setTotalPages(Data?.totalPages);
        setCurrentPage(Data?.page);
        setHasNext(Data?.hasNextPage);
        setHasPrev(Data?.hasPrevPage);
        setPageCounter(Data?.pagingCounter);
        setListLoader(false);
        setISInitialData(true);
        dispatch(setLoadingPage(false));
      } catch (error) {
        console.log(error);
      }
    };

    getCustomerDetailList();
  }, [
    searchKeyword,
    pageLimit,
    currentPage,
    sortOrder,
    customer_code,
    sortKey,
    fieldType
  ]);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected + 1);
    setListLoader(true);
  };

  const renderSortIcon = (key) => {
    if (sortKey !== key) return <img src={DescIcon} alt="Descending" />;
    return sortOrder === -1 ? (
      <img src={DescIcon} alt="Descending" />
    ) : sortOrder === 1 ? (
      <img src={AscIcon} alt="Ascending" />
    ) : null;
  };
  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === -1 ? 1 : -1);
      setCurrentPage(1);
      setListLoader(true);
    } else {
      setSortKey(key);
      setSortOrder(1);
      setCurrentPage(1);
      setListLoader(true);
    }
  };


    const getCustomerCategoryList = async () => {
      try {
        const resp = await axios.post(
          `${API_CALL_URL_PRIVATE}/costcentercategory/distinctList`,
          {
            customer_code: parseInt(customer_code),
          }
        );

        const Data = resp?.data?.data?.data;

        const drop_facility = Data?.map((e) => {
          return {
            label: e?.cost_center_category,
            value: e?.cost_center_category_id,
          };
        });
        setCostCenterList([...drop_facility]);
        return drop_facility;
      } catch (error) {
        console.log(error);
      }
    };

    function getCostCenterCategoryIds(data) {
      if (!data || data.length === 0) {
        return "N/A";
      }
      return data.map((item) => item.cost_center_category_id).join(", ");
    }


    // useEffect(() => {
    //   getCustomerCategoryList();
    // }, []);
    

  return (
    <>
      <div className="main-panel">
        <div className="content-wrapper">
          <div className="page-header">
            <h3 className="page-title">
              <a href="#" className="badge badge-dark"></a>
            </h3>
            <div className></div>
          </div>
          <div className="row">
            <div className="col-lg-12 grid-margin stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between mb-4">
                    <h4 className="card-title">
                      All RealTime Graphs (Pay Period)
                    </h4>

                    {(userData?.employee_id === 11115 ||
                      userData?.employee_id === 11111) && (
                      <Link
                        className="boxlink"
                        to="/admin/realtime-graphs/add"
                      >
                        {" "}
                        <button type="button" class="btn btn-success">
                          Add Field
                        </button>
                      </Link>
                    )}
                  </div>
                  <div className="d-flex justify-content-between mobile-wrap">
                    <div class="dataTables_length" id="example_length">
                      <label>
                        Show &nbsp;
                        <select
                          name="example_length"
                          aria-controls="example"
                          class=""
                          value={pageLimit}
                          onChange={(e) => {
                            setPageLimit(e.target.value);
                            setListLoader(true);
                          }}
                        >
                          <option value="5">5</option>
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>{" "}
                        &nbsp;entries
                      </label>
                    </div>
                    <form
                      onSubmit={(e) => {
                        e.preventDefault(); // Prevent the default form submission behavior
                        if (searchKeyword !== searchTempKeyword) {
                          flushSync(() => {
                            setSearchActive(true);
                            setSortKey("");
                          });
                          setListLoader(true);
                          setSearchKeyword(searchTempKeyword);
                        }
                      }}
                    >
                      <div
                        id="example_filter"
                        class="dataTables_filter d-flex align-items-center justify-content-center "
                      >
                        <label>
                          Search: &nbsp;
                          <input
                            type="text"
                            class=""
                            placeholder=""
                            aria-controls="example"
                            onChange={(e) => {
                              setSearchTempKeyword(e.target.value);
                              if (e.target.value === "") {
                                setListLoader(true);
                                setSearchKeyword("");
                              }
                            }}
                            // onKeyDown={(e) => {
                            //   if (e.key === "Enter") {
                            //     setSearchKeyword(e.target.value);
                            //   }
                            // }}
                          />
                        </label>

                        <div
                          style={{
                            border: "1px solid #aaa",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "9px",
                            marginBottom: "7px",
                            cursor: "pointer",
                            marginTop: "-1px",
                            marginLeft: "-1px",
                          }}
                          onClick={() => {
                            if (searchKeyword !== searchTempKeyword) {
                              flushSync(() => {
                                setSearchActive(true);
                                setSortKey("");
                              });
                              setListLoader(true);
                              setSearchKeyword(searchTempKeyword);
                            }
                          }}
                        >
                          <i class="ph ph-magnifying-glass"></i>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div>
                    <div className="table-responsive">
                      <table className="table filter-table">
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th
                              onClick={() => {
                                handleSort("field_name");
                              }}
                            >
                              Field Name
                              <span className="ms-1 bright">
                                {renderSortIcon("field_name")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("category_ids");
                              }}
                            >
                              Category ID
                              <span className="ms-1 bright">
                                {renderSortIcon("category_ids")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("display_on_workdriver");
                              }}
                            >
                              Display On WorkDriver
                              <span className="ms-1 bright">
                                {renderSortIcon("display_on_workdriver")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("display_on_trends");
                              }}
                            >
                              Display On Trends
                              <span className="ms-1 bright">
                                {renderSortIcon("display_on_trends")}
                              </span>
                            </th>

                            <th
                              onClick={() => {
                                handleSort("updatedAt");
                              }}
                            >
                              Updated At
                              <span className="ms-1 bright">
                                {renderSortIcon("updatedAt")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("createdAt");
                              }}
                            >
                              Created At
                              <span className="ms-1 bright">
                                {renderSortIcon("createdAt")}
                              </span>
                            </th>
                            <th
                              onClick={() => {
                                handleSort("notes");
                              }}
                            >
                              Notes
                              <span className="ms-1 bright">
                                {renderSortIcon("notes")}
                              </span>
                            </th>

                            {/* <th
                          onClick={() => {
                            setSortKey("status");
                            setSortOrder(sortOrder === 1 ? -1 : 1);
                          }}
                        >
                          Status
                        </th> */}
                            {(userData?.employee_id === 11115 ||
                              userData?.employee_id === 11111) && <th></th>}
                          </tr>
                        </thead>
                        {isInitialData && !loading_page && !listLoader ? (
                          <>
                            {customerData?.docs?.length > 0 ? (
                              <tbody>
                                {customerData?.docs?.map((Ele, i) => {
                                  return (
                                    <tr key={Ele._id}>
                                      <td>{i + pageCounter}</td>
                                      <td>{Ele?.field_name}</td>
                                      <td>
                                        {getCostCenterCategoryIds(
                                          Ele?.categoryids
                                        )}
                                      </td>
                                      <td>{Ele?.display_on_workdriver ? "Yes" : "No"}</td>
                                      <td>{Ele?.display_on_trends ? "Yes" : "No"}</td>
                                      <td>{getDate(Ele?.updatedAt)}</td>
                                      <td>{getDate(Ele?.createdAt)}</td>
                                      {Ele?.notes ? (
                                        <td>
                                          <OverlayTrigger
                                            key={"top"}
                                            placement={"top"}
                                            overlay={
                                              <Tooltip id={`tooltip-${"top"}`}>
                                                <strong>{"Formula:"}</strong>
                                                &nbsp; {Ele?.notes}
                                              </Tooltip>
                                            }
                                          >
                                            <img
                                              src={calcIcon}
                                              alt=""
                                              style={{
                                                width: "36px",
                                                height: "auto",
                                                cursor: "pointer",
                                              }}
                                            />
                                          </OverlayTrigger>
                                        </td>
                                      ) : (
                                        <td></td>
                                      )}
                                      {(userData?.employee_id === 11115 ||
                                        userData?.employee_id === 11111) && (
                                        <td>
                                          <label className="edit">
                                            <Link
                                              className="boxlink"
                                              to={`/admin/realtime-graphs/edit/${Ele?._id}`}
                                            >
                                              <img
                                                src={Ico1}
                                                className="w-a"
                                                alt="icon"
                                              />
                                            </Link>
                                          </label>
                                        </td>
                                      )}
                                    </tr>
                                  );
                                })}
                              </tbody>
                            ) : (
                              <tbody>
                                <tr>
                                  <td colSpan="6">
                                    <div
                                      className="d-flex justify-content-center align-items-center"
                                      style={{ height: "200px" }}
                                    >
                                      <p class="text-secondary display-6">
                                        Oops! Data Not found
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            )}
                          </>
                        ) : (
                          <>
                            <tbody>
                              <tr>
                                <td colSpan="10">
                                  <div
                                    className="d-flex align-items-center justify-content-center w-100"
                                    style={{ height: "400px" }}
                                  >
                                    <span
                                      class="loader"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                      }}
                                    ></span>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </>
                        )}
                      </table>
                    </div>

                    {isInitialData && !loading_page && !listLoader ? (
                      <>
                        <div className="d-flex justify-content-between">
                          <div
                            class="dataTables_info"
                            id="example_info"
                            role="status"
                            aria-live="polite"
                          >
                            Showing {pageCounter} to{" "}
                            {Math.min(
                              pageCounter + pageLimit - 1,
                              customerData.totalDocs
                            )}{" "}
                            of total {customerData?.totalDocs} entries
                          </div>
                          <div
                            class="dataTables_paginate paging_simple_numbers"
                            id="example_paginate"
                          >
                            <span>
                              <ReactPaginate
                                previousLabel={"Previous"}
                                nextLabel={"Next"}
                                breakLabel={"..."}
                                pageCount={customerData?.totalPages}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination"}
                                previousLinkClassName={"paginationLink"}
                                nextLinkClassName={"paginationLink"}
                                disabledClassName={"paginationDisabled"}
                                activeClassName={"paginationActive"}
                                forcePage={currentPage - 1}
                              />
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Applications;
